module.exports = __webpack_public_path__ + "img/CTO-Ihrom-Bayu-new.8d5581ed.jpg";